<template>
  <a
    :href="link"
    class="ca-header__logo-ca"
    :class="{ 'ca-header__logo-ca--always-visible': isSimplifiedMenu }"
    aria-label="Ir para a página inicial"
    v-show="visible"
  >
    <img :src="imageUrl" alt="Logo CA" />
  </a>
  <a
    :href="link"
    class="ca-header__logo-ca ca-header__logo-ca--secondary"
    aria-label="Ir para a página inicial"
    v-show="visible && !isSimplifiedMenu"
  >
    <img :src="imageSecondaryUrl" alt="Logo CA" />
  </a>
  <a
    :href="link"
    class="ca-header__logo-ca ca-header__logo-ca--secondary-small"
    aria-label="Ir para a página inicial"
    v-show="visible && !isSimplifiedMenu"
  >
    <img :src="imageSecondarySmallUrl" alt="Logo CA" />
  </a>
</template>

<script setup>
defineProps({
  link: { type: String, default: "/" },
  imageUrl: { type: String, default: "" },
  imageSecondaryUrl: { type: String, default: "" },
  imageSecondarySmallUrl: { type: String, default: "" },
  visible: { type: Boolean, default: true },
  isSimplifiedMenu: { type: Boolean, default: false },
});
</script>

<style scoped lang="scss">
.ca-header__logo-ca {
  cursor: pointer;
  padding: 0 var(--size-3);

  &:focus-visible {
    outline: 1px solid var(--ca-color-feedback-info);
  }

  &--always-visible {
    display: flex !important;
  }

  &--secondary,
  &--secondary-small {
    display: none;
  }

  @media (min-width: 1178px) and (max-width: 1556px) {
    &,
    &--secondary-small {
      display: none;
    }

    &--secondary {
      display: flex;
    }
  }

  @media (min-width: 1121px) and (max-width: 1178px) {
    &,
    &--secondary {
      display: none;
    }

    &--secondary-small {
      display: flex;
    }
  }

  @media (max-width: 1120px) {
    & {
      display: flex;
    }

    &--secondary,
    &--secondary-small {
      display: none;
    }
  }
}

@media (max-width: 1024px) {
  .ca-header__logo-ca {
    padding: 0;
  }
}
</style>
